import { loadCss, loadModules } from 'esri-loader';
import * as Constants from "./constants";

//++++++++++++++++++++++++++++
// 4.14 and 4.15 have a bug in the measurement tool that does not trap the mouse click.
// Identify happens with every measurement click. Make sure to test that when upgrading.
//++++++++++++++++++++++++++++
export const initMap = () => {
  console.log("map.initMap");
  loadCss('https://js.arcgis.com/4.20/esri/css/main.css');
  return loadModules([
    "esri/Map",
    "esri/views/MapView",
    "esri/layers/MapImageLayer",
    "esri/layers/FeatureLayer",
    "esri/layers/TileLayer",
    "esri/layers/GraphicsLayer",
    "esri/layers/WMSLayer",
    "esri/geometry/Point",
    "esri/geometry/Extent",
    "esri/Graphic",
    "esri/tasks/IdentifyTask",
    "esri/tasks/support/IdentifyParameters",
    "esri/tasks/FindTask",
    "esri/tasks/support/FindParameters",
    "esri/tasks/QueryTask",
    "esri/tasks/support/Query",
    "esri/tasks/support/RelationshipQuery",
    "esri/tasks/Locator",
    "esri/tasks/PrintTask",
    "esri/tasks/support/PrintTemplate",
    "esri/tasks/support/PrintParameters",
    "esri/tasks/GeometryService",
    "esri/tasks/support/BufferParameters",
    "esri/widgets/LayerList",
    "esri/widgets/Legend",
    "esri/widgets/Measurement",
    "esri/geometry/SpatialReference"
  ], {
      url: 'https://js.arcgis.com/4.20/'
    })
    .then(([
      Map,
      MapView,
      MapImageLayer,
      FeatureLayer,
      TileLayer,
      GraphicsLayer,
      WMSLayer,
      Point,
      Extent,
      Graphic,
      IdentifyTask,
      IdentifyParameters,
      FindTask,
      FindParameters,
      QueryTask,
      Query,
      RelationshipQuery,
      Locator,
      PrintTask, PrintTemplate, PrintParameters,
      GeometryService,
      BufferParameters,
      LayerList,
      Legend,
      Measurement,
      SpatialReference
    ]) => {
      let map = new Map();

      let grayLayer = new TileLayer({
        listMode: "hide",
        url: Constants.grayBasemapUrl
      });
      map.add(grayLayer);

      // let imageLayer = new TileLayer({
      //   listMode: "hide",
      //   url: Constants.imageUrl
      // });
      // map.add(imageLayer);
      let nearMapLayer = new WMSLayer({
        id: "nearMapLayer",
        title: "Latest NearMap Imagery",
        url: Constants.nearMAPURL,
        sublayers: [{
          name: "area/1459a757-8a92-4773-aada-4ad9090114a6/all/all-combined",
          title: "Latest NearMap Imagery",
          visible: true
        }]
      });
      map.add(nearMapLayer);

      // let basemapLayer = new MapImageLayer({
      //   id: "basemapPlus",
      //   listMode: "hide",
      //   url: Constants.basemapUrl
      // });
      // map.add(basemapLayer);

      let landRecordsLayer = new MapImageLayer({
        id: "landRecordsLayer",
        title: "Map Features",
        url: Constants.landRecordsUrl
      });
      map.add(landRecordsLayer);

      let view = new MapView({
        container: "main-right",
        map: map,
        center: [-117.263, 33.049],
        zoom: 13
      });

      return ({
        mapView: view,
        Point: Point,
        Extent: Extent,
        Graphic: Graphic,
        GraphicsLayer: GraphicsLayer,
        FeatureLayer: FeatureLayer,
        LayerList: LayerList,
        Legend: Legend,
        Measurement: Measurement,
        IdentifyTask: IdentifyTask,
        IdentifyParameters: IdentifyParameters,
        FindTask: FindTask,
        FindParameters: FindParameters,
        QueryTask: QueryTask,
        Query: Query,
        RelationshipQuery: RelationshipQuery,
        Locator: Locator,
        PrintTask: PrintTask, PrintTemplate: PrintTemplate, PrintParameters: PrintParameters,
        GeometryService: GeometryService,
        BufferParameters: BufferParameters,
        SpatialReference: SpatialReference
      });
  });
};
